export const styles = {
  card: { padding: '2.5rem', marginBottom: '2rem' },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  row: {
    marginBottom: '2rem',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Settings/Documentation/styles.js